import { booleanAttribute, Directive, Input, Optional } from '@angular/core';
import { MapDynamicData } from 'libs/map/src/lib/dynamic-data.service';
import { Subject, takeUntil } from 'rxjs';
import { AirspaceCheckService } from './airspace-check';
import { mapSourceFiltersForResponse } from './helpers';

/**
 * This directive will ensure that the map displays all the relevant map layers, by relaying updates from the airspace checker to the map dynamic data service.
 */
@Directive({
    selector: 'flyfreely-map[airspaceCheckResult]'
})
export class AirspaceCheckResultDirective {
    @Input({ transform: booleanAttribute }) airspaceCheckResult = true;

    private ngUnsubscribe$ = new Subject<void>();
    constructor(
        @Optional() private airspaceCheckService: AirspaceCheckService,
        private dynamicDataService: MapDynamicData
    ) {}

    ngOnInit() {
        if (!this.airspaceCheckResult) {
            return;
        }
        if (this.airspaceCheckService == null) {
            throw new Error(
                'airspaceCheckResult is enabled, so requires an AirspaceCheckService'
            );
        }
        this.airspaceCheckService.result$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(result =>
                this.dynamicDataService.setProgrammaticMapConfig(
                    this,
                    result != null
                        ? {
                              mapSourceFilters:
                                  mapSourceFiltersForResponse(result),

                              enabledLayerGroups: Object.keys(
                                  result.automatedAuthorisationLayerGroups
                              ).reduce(
                                  (acc, key) =>
                                      acc.concat(
                                          result
                                              .automatedAuthorisationLayerGroups[
                                              key
                                          ]
                                      ),
                                  [] as string[]
                              )
                          }
                        : { enabledLayerGroups: [], mapSourceFilters: {} }
                )
            );
    }
    ngOnDestroy() {
        this.dynamicDataService.clearProgrammaticMapConfig(this);
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}
